import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import { orderDetailsGet, viewTechDetailsGet } from "../../../constants";
import { AppContext } from "../../../Context/AppContext";
import dateFormat from "dateformat";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";

function ViewOrderDetail() {
  const {
    userInfo,
    defaultPane,
    orderFilter,
    selectedBuilding,
    appVersion,
    isAppVersionOutdated,
  } = useContext(AppContext);
  const [user, setUser] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const history = useHistory();
  const location = useLocation();
  const [data, setData] = useState();
  const [, set_default_pane] = defaultPane;
  const [, set_order_filter] = orderFilter;
  const [selected_building, setSelectedBuilding] = selectedBuilding;
  const [var_mdl_progress, set_mdl_progress] = useState(false);

  useEffect(() => {
    if (location.state && location.state.id) {
      getOrderDetails();
    } else {
      history.goBack();
    }
    if (location.state.orderlist === true) {
      set_default_pane(1);
    } else {
      set_default_pane(0);
    }
    if (location.state.orderFilter) {
      set_order_filter(location.state.orderFilter);
    }
  }, []);

  async function getOrderDetails() {
    var id = location.state.id;
    var unit_number = location.state.unit_number;
    set_mdl_progress(true);
    const requestHeaders = {
      headers: {
        entityid: selected_building?.value,
        appversion: var_app_version,
      },
    };
    await fetch(
      user.role === "technician" || !unit_number
        ? viewTechDetailsGet + id
        : orderDetailsGet + "?id=" + id + "&unit_number=" + unit_number,
      requestHeaders,
    )
      .then((resposnse) => resposnse.json())
      .then((res) => {
        if (res.code === 200) {
          setData(res.data);
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        set_mdl_progress(false);
      })
      .catch((error) => {
        set_mdl_progress(false);
        console.error("Error:", error);
      });
  }

  return (
    <div className="app-content">
      <div className="order-review-contaienr">
        <div className="order-review-header">
          <div className="order-review-title">Service Request Details</div>
          <div className="order-review-subtitle">
            <span>Location:</span>
            <span>{data ? data.building_name : "No name"}</span>
          </div>
          <div className="order-review-subtitle">
            <span>Submission Date &amp; Time: </span>
            <span>
              {data && data.order_date_time
                ? dateFormat(new Date(data.order_date_time), "mm-dd-yyyy hh:mm")
                : "No date"}
            </span>
          </div>
          {data && data.po_mo_wo && (
            <div className="order-review-subtitle">
              <span>
                {" "}
                {data.po_mo_wo.toString().toLowerCase() === "po"
                  ? "Purchase Order Number:"
                  : data.po_mo_wo.toString().toLowerCase() === "mo"
                    ? "Maintenance Order Number: "
                    : "Work Order Number: "}
              </span>
              <span>
                {data.purchase_order_number ? data.purchase_order_number : 0}
              </span>
            </div>
          )}
          <div className="order-review-subtitle">
            <span>Status: </span>
            <span style={{ textTransform: "capitalize" }}>
              {data?.order_status || "No Status"}
            </span>
          </div>
          <div className="order-review-subtitle">
            <span>Scheduled Date: </span>
            <span>
              {data && data.schedule_date
                ? dateFormat(new Date(data.schedule_date), "mm-dd-yyyy")
                : "N/A"}
            </span>
          </div>
          {/* <div className="order-review-subtitle">
                        <span>Scheduled Time: </span>
                        <span>{data && data.time_range ? data.time_range :"N/A"}</span>
                    </div> */}
        </div>
        {data &&
          data.units.map((vals) => (
            <div className="order-review-unit">
              <div className="app-card">
                <div className="unit-detail-row">
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Unit #</div>
                    <div className="unit-detail-value">{vals.unit_number}</div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Pest Requested</div>
                    <div className="unit-detail-value">
                      {vals.pest_name ? vals.pest_name : "No name"}
                    </div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Treatment Requested</div>
                    <div className="unit-detail-value">
                      {vals.treatment_name ? vals.treatment_name?.toLowerCase() === "activate treatment" ? "Activate (Actisol) Treatment" : vals.treatment_name : "No name"}
                    </div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Price</div>
                    <div className="unit-detail-value">
                      ${vals.price ? vals.price : "0"}
                    </div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Type of Request</div>
                    <div className="unit-detail-value">
                      {vals.follow_up === 1
                        ? "Follow-Up"
                        : vals.isFollowupMonthly
                          ? "Follow-Up (Service In Month)"
                          : vals.isImmediate
                            ? "Follow-Up (Immediate)"
                            : vals.is_reschedule
                              ? "Reschedule"
                              : "New"}
                    </div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Notes</div>
                    <div className="unit-detail-value">
                      {vals.note ? vals.note : "No notes"}
                    </div>
                  </div>
                  <div className="unit-detail-col">
                    <div className="unit-detail-label">Time Window</div>
                    <div className="unit-detail-value">
                      {location?.state?.unit_number
                        ? vals.time_range
                          ? vals.time_range
                          : "N/A"
                        : data?.time_range
                          ? data.time_range
                          : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        <div className="page-form-submit">
          <div className="page-form-submit-button">
            <Button color="red" onClick={history.goBack}>
              Go Back
            </Button>
          </div>
        </div>
      </div>
      {/***** MODAL: PROGRESS **************************************************************************/}

      <Modal
        id="mdl-progress"
        dimmer={"inverted"}
        open={var_mdl_progress}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        onClose={() => {}}
      >
        <MDL_PROGRESS
          set_mdl_open={set_mdl_progress}
          var_modaltitle="Please wait"
          var_message={"Please wait..."}
        ></MDL_PROGRESS>
      </Modal>

      {/***** END MODAL: PROGRESS **************************************************************************/}
    </div>
  );
}

export default ViewOrderDetail;
